import cx from 'clsx';

import { SectionContainer as BaseSectionContainer } from '../base';
import { contentWidthConfigMap, variantConfigMap } from './configs';
import {
  SECTION_CONTAINER_VARIANT_NORMAL,
  SECTION_CONTENT_WIDTH_NORMAL,
} from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const SectionContainer: Component = ({
  children,
  description,
  className,
  contentClassName,
  containerRef,
  title,
  titleLink,
  titleAfterContent,
  titleAsideContent,
  titleAfterContentClassName,
  titleAsideContentClassName,
  titleHeading,
  variant = SECTION_CONTAINER_VARIANT_NORMAL,
  contentWidth = SECTION_CONTENT_WIDTH_NORMAL,
  trackingSelector,
}) => {
  const {
    [variant]: {
      className: variantClassName,
    },
  } = variantConfigMap;
  const {
    [contentWidth]: {
      className: contentWidthClassName,
    },
  } = contentWidthConfigMap;

  return (
    <BaseSectionContainer
      className={cx(
        styles.containerRoot,
        styles[variantClassName],
        className,
      )}
      containerRef={containerRef}
      contentClassName={cx(
        styles.containerContent,
        styles[variantClassName],
        styles[contentWidthClassName],
        contentClassName,
      )}
      description={description}
      descriptionClassName={cx(
        styles.containerDescription,
        styles[variantClassName],
        styles[contentWidthClassName],
      )}
      title={title}
      titleAfterContent={titleAfterContent}
      titleAfterContentClassName={titleAfterContentClassName}
      titleAsideContent={titleAsideContent}
      titleAsideContentClassName={titleAsideContentClassName}
      titleContainerClassName={cx(
        styles.containerTitle,
        styles[variantClassName],
      )}
      titleHeading={titleHeading}
      titleLink={titleLink}
      titleTextClassName={cx(
        styles.textTitle,
        styles[variantClassName],
      )}
      trackingSelector={trackingSelector}>
      {children}
    </BaseSectionContainer>
  );
};
